/* @flow */

export const QUEUE_NOTIFICATION = 'QUEUE_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
